import React, { useMemo } from 'react';
import { AFFILIATES } from '../../../../../../common/constants/appConstant';
import { getUrlParamsMapV2, getUrlWithParams } from '../../../../../../common/utils/browserUtils';
import './affiliateSwitchToggle.css';

const AffiliateSwitchToggle = props => {
  const { affiliate } = props;
  const isSelected = useMemo(() => {
    const params = getUrlParamsMapV2();
    return params.affiliate === affiliate;
  }, []);

  const onHandleChange = () => {
    const params = getUrlParamsMapV2();
    if (isSelected) {
      params.affiliate = AFFILIATES.MMT;
    } else {
      params.affiliate = affiliate;
    }
    window.location.href = getUrlWithParams(params);
  };

  return (
    <div className="affiliate-section-bottom makeFlex spaceBetween">
      <div className="makeFlex hrtlCenter">
        <span>
          <span className="font13 latoBlack">{affiliate}</span>
        </span>
      </div>
      <div className="switch">
        <input
          id={`switch__input_${affiliate}`}
          className="switch-toggle switch-toggle-round"
          type="checkbox"
          checked={isSelected ? 'checked' : ''}
          onChange={onHandleChange}
        />
        <label htmlFor={`switch__input_${affiliate}`} />
      </div>
    </div>
  );
};

export default AffiliateSwitchToggle;
